@use '@/scss/underscore' as _;

.description {
  color: var(--color-text-secondary);
  font: var(--font-body-2);
  margin-bottom: _.unit(1);
}

.connectorName {
  display: flex;
  align-items: center;

  .icon {
    background: transparent;
    width: 20px;
    height: 20px;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .name {
    margin-left: _.unit(3);
  }
}

.userId {
  display: flex;
  align-items: center;
  font: var(--font-body-2);
  font-family: 'Roboto Mono', monospace;
  line-height: 32px;

  span {
    display: inline-block;
    @include _.text-ellipsis;
  }
}
